import React, { useState } from 'react';
import { api_updateBanner } from '../../../api/banner';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getImageUrl } from '../../../api';

const EditBanner = () => {
	const banner = useLocation().state;
	const [loading, setLoading] = useState<boolean>(false);
	const [image, setImage] = useState<File | null>(null);
	const navigate = useNavigate();

	const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files[0]) {
			setImage(event.target.files[0]);
		}
	};

	const edit = async () => {
		try {
			setLoading(true);
			const payload = new FormData();
			if (image) {
				payload.append('image', image);
			}

			const res = await api_updateBanner(banner._id, payload);
	 // Debugging: Check the response

			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 1000); // Navigate back after 1 second
			}
		} catch (error) {
			console.error('Error editing banner:', error);
			toast.error('An error occurred while editing banner');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<label htmlFor='currentImage' className='form-label'>
					Current Image
				</label>
				{banner && (
					<img
						src={getImageUrl(banner.image)}
						alt='Current Banner'
						style={{ width: '400px', borderRadius: '8px', objectFit: 'cover' }}
						className='form-control form-control-sm'
					/>
				)}
			</div>
			<div className='mb-3'>
				<label htmlFor='newImage' className='form-label'>
					New Image
				</label>
				<input
					onChange={handleImageChange}
					style={{ width: '100%', maxWidth: '400px' }}
					className='form-control form-control-sm'
					id='newImage'
					type='file'
				/>
			</div>
			<button
				onClick={edit}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading || !image}>
				{loading ? 'Loading...' : 'Submit'}
			</button>
		</div>
	);
};

export default EditBanner;
